import React from 'react';
import './CreatePasswordComponent.less';
import {ButtonPrimary, ButtonLink} from '@homeaway/react-buttons';
import aamClient from '../../util/aamClient';

function CreatePasswordComponent({displayButton, emailAddress, handleError, lingua, service, updatePage}) {
    function returnToResetPassword() {
        const body = {
            emailAddress,
            serviceUrl: service
        };

        aamClient.passwordReset(body).then(({status}) => {
            if (status === 204) {
                updatePage('passwordreset');
            } else {
                handleError(lingua.read('error.generic'), '');
            }
        });
    }
    return (
        <div className="text-center">
            {displayButton === true &&
                <ButtonPrimary className="Create-password-btn" label={lingua.read('lex.password.create.mu')} onClick={returnToResetPassword}/>
            }
            {displayButton !== true &&
                <ButtonLink className="Link" label={lingua.read('lex.password.create.option')} onClick={returnToResetPassword}/>
            }
        </div>
    );
}

export default CreatePasswordComponent;
